<template>
  <nav
    class="fixed bottom-0 left-0 w-full z-50 flex justify-around items-end px-2 pb-2 h-[80px] bg-surface/95 dark:bg-surface-dim/95 backdrop-blur-md border-t border-outline-variant/30"
  >
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      :aria-label="tab.label"
      :aria-current="activeTab === tab.id ? 'page' : 'false'"
      :class="[
        tab.center
          ? 'flex-1 flex flex-col items-center mb-4'
          : 'app-tab flex-1 flex flex-col items-center justify-center py-2 active:scale-95 transition-transform',
        activeTab === tab.id ? 'text-primary' : 'text-on-surface-variant'
      ]"
      @click="$emit('switch', tab.id)"
    >
      <!-- Center FAB -->
      <template v-if="tab.center">
        <div
          class="w-14 h-14 bg-primary-container text-on-primary-container rounded-full flex flex-col items-center justify-center shadow-lg active:scale-90 transition-all border-4 border-surface"
          :class="{ 'ring-2 ring-primary/30': activeTab === tab.id }"
        >
          <span class="material-symbols-outlined" style="font-size: 32px;" aria-hidden="true">{{ tab.icon }}</span>
        </div>
        <span class="text-[10px] font-bold mt-1" :class="activeTab === tab.id ? 'text-primary' : 'text-on-surface-variant'">{{ tab.label }}</span>
      </template>

      <!-- Normal tab -->
      <template v-else>
        <span
          class="material-symbols-outlined app-tab-icon"
          aria-hidden="true"
         :style="{ fontVariationSettings: activeTab === tab.id ? `'FILL' 1` : `'FILL' 0` }"
        >{{ tab.icon }}</span>
        <span
          class="font-label-md text-label-md mt-1"
          :class="{ 'font-semibold': activeTab === tab.id }"
        >{{ tab.label }}</span>
      </template>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'AppTabbar',
  props: {
    activeTab: { type: String, default: 'home' }
  },
  data() {
    return {
      tabs: [
        { id: 'home', icon: 'home', label: '首页' },
        { id: 'nearby', icon: 'groups', label: '圈子' },
        { id: 'publish', icon: 'add', label: '发布', center: true },
        { id: 'wanted-list', icon: 'favorite', label: '求购' },
        { id: 'profile', icon: 'person', label: '我的' }
      ]
    };
  }
};
</script>
